import { getAllAssets } from 'helpers/selectors';
import { createSelector } from 'reselect';
import sortBy from 'lodash/sortBy';
import { filterAssetsForReportGeneration, getFilterForReportType } from './helpers';
import { getReportCapabilities } from '../selectors';

import { hasCapability, isSensorTypeMSR } from '../helpers';
import { NEWCAPABILITIES } from 'helpers/constants';
import { reportTypes } from '../constants';


// export const getAssetsForReportType = createSelector(
//     [
//         getAllAssets,
//         (_, filterObject) => filterObject
//     ],
//     (assets, filterObject) => filterAssetsForReportGeneration(assets, filterObject)
// );

const getIsModalOpen = ({ reports }) => {
    return reports?.reportGenerator.isModalOpen;
};

const getCapabilitiesLoadingStatuses = ({ reports }) => {
    return Object.values(reports?.reportGenerator?.capabilities).map((capability) => capability?.loadingStatus);
};

const getSelectedReportType = ({ reports }) => {
    return reports?.reportGenerator?.selectedReportType;
};

const getSensorOfAssets = ({ reports }) => {
    return reports?.sensorOfAssets?.data;
};

// eslint-disable-next-line import/no-unused-modules
export const getRawDataCollections = ({ reports }) => {
    return reports?.rawDataCollections;
};

const getPreselectedAsset = ({ reports }) => {
    return reports?.reportGenerator?.preselectedAsset || null;
};

const getAssetOptions = createSelector(
    [
        getAllAssets,
        getReportCapabilities,
        getSensorOfAssets,
        getSelectedReportType,
    ],
    (assets, reportCapabilities, sensorOfAssets, selectedReportType) => {
        return filterAssetsForReportGeneration(sortBy(assets.filter((asset) => {
            const isFleetDetailReport = selectedReportType?.reportTypeId === reportTypes.MotorFleetDetailedInstantReport ||
                selectedReportType?.reportTypeId === reportTypes.DriveFleetDetailedInstantReport;
            const hasRequiredCapability = isFleetDetailReport
                ? hasCapability(asset.id, reportCapabilities, NEWCAPABILITIES.fleetDetailedReport)
                : hasCapability(asset.id, reportCapabilities, NEWCAPABILITIES.assetInstantReport);

            // Only filter by isMonitored for Fleet Detail Reports
            const isMonitored = isFleetDetailReport ? asset?.isMonitored : true;

            return hasRequiredCapability && !isSensorTypeMSR(asset, sensorOfAssets) && isMonitored;
        }), (o) => (o?.componentName || '').toLowerCase()), getFilterForReportType(selectedReportType));
    }
);

export const getModel = createSelector([
    getIsModalOpen,
    getCapabilitiesLoadingStatuses,
    getAssetOptions,
    getPreselectedAsset
],
    (
        isModalOpen,
        capabilitiesLoadingStatuses,
        assetOptions,
        preselectedAsset
    ) => {
        return {
            isModalOpen,
            capabilitiesLoadingStatuses,
            assetOptions,
            preselectedAsset
        };
    });
